import * as yup from "yup";
import React, { useRef } from "react";
import { Constants } from "../../helpers/Constants";
import { ComplianceOptions } from "./Home/ApplicationDetails.types";

export type DrainFieldInstallationInspectionFormProps = {
  id: string;
  returnPath: string;
    title: string;
    applicationInspectionId?: number;
    applicationId?: number;
    values?: DrainFieldInstallationInspectionInput;
  action: "post" | "put";
};

export type DrainFieldInstallationInspectionInput = {
  drainfieldInstallationId: number;
  applicationId: number;
  applicationInspectionId: number;
  areaComplianceId: number;
  areaCompliance?: ComplianceOptions;
  areaComment: string;
  area1: number;
  productComplianceId1: number;
  productComplianceId1Navigation?: ComplianceOptions;
  productComment1: string;
  productMakeId1: number;
  productMakeId1Navigation?: DrainfieldProductMakeOption;
  productModelId1: number;
  productModelId1Navigation?: DrainfieldProductModelOption;
  configuration: string;
  distributionComplianceId: number;
  distributionCompliance?: ComplianceOptions;
  distributionComment: string;
  distribution: string;
  numberOfDrainlinesComplianceId: number;
  numberOfDrainlinesCompliance?: ComplianceOptions;
  numberOfDrainlinesComment: string;
  numberOfDrainline1: number;
  numberOfUnits1: number;
  drainlineSeparationComplianceId: number;
  drainlineSeparationCompliance?: ComplianceOptions;
  drainlineSeparationComment: string;
  drainlineSlopeComplianceId: number;
  drainlineSlopeCompliance?: ComplianceOptions;
  drainlineSlopeComment: string;
  depthOfCoverComplianceId: number;
  depthOfCoverCompliance?: ComplianceOptions;
  depthOfCoverComment: string;
  elevationComplianceId: number;
  elevationCompliance?: ComplianceOptions;
  elevationComment: string;
  elevation1: string;
  elevation2: number;
  systemLocationComplianceId: number;
  systemLocationCompliance?: ComplianceOptions;
  systemLocationComment: string;
  dosingPumpComplianceId: number;
  dosingPumpCompliance?: ComplianceOptions;
  dosingPumpComment: string;
  dosingPump: number;
  aggregateSizeComplianceId: number;
  aggregateSizeCompliance?: ComplianceOptions;
  aggregateSizeComment: string;
  aggregateExcessiveComplianceId: number;
  aggregateExcessiveCompliance?: ComplianceOptions;
  aggregateExcessiveComment: string;
  aggregateDepthComplianceId: number;
  aggregateDepthCompliance?: ComplianceOptions;
  aggregateDepthComment: string;

  productComplianceId2?: number;
  productComplianceId2Navigation?: ComplianceOptions;
  productComment2?: string;
  productMakeId2?: number;
  productMakeId2Navigation?: DrainfieldProductMakeOption;
  productModelId2?: number;
  productModelId2Navigation?: DrainfieldProductModelOption;
  areaComplianceId2?: number;
  areaComplianceId2Navigation?: ComplianceOptions;
  areaComment2?: string;
  area2?: number;
  distributionComplianceId2?: number;
  distributionComplianceId2Navigation?: ComplianceOptions;
  distributionComment2?: string;
  distributionBoxOrHeader2?: string;
  numberOfDrainlinesComplianceId2?: number;
  numberOfDrainlinesComplianceId2Navigation?: ComplianceOptions;
  numberOfDrainlinesComment2?: string;
  numberOfDrainline12?: number;
  numberOfUnits2?: number;
  drainlineSeparationComplianceId2?: number;
  drainlineSeparationComplianceId2Navigation?: ComplianceOptions;
  drainlineSeparationComment2?: string;
  drainlineSeparationBedOrTrench2?: string;
  drainlineSlopeComplianceId2?: number;
  drainlineSlopeComplianceId2Navigation?: ComplianceOptions;
  drainlineSlopeComment2?: string;
  depthOfCoverComplianceId2?: number;
  depthOfCoverComplianceId2Navigation?: ComplianceOptions;
  depthOfCoverComment2?: string;
  elevationComplianceId2?: number;
  elevationComplianceId2Navigation?: ComplianceOptions;
  elevationComment2?: string;
  elevation12?: string;
  elevationBenchmark2?: string;
  systemLocationComplianceId2?: number;
  systemLocationComplianceId2Navigation?: ComplianceOptions;
  systemLocationComment2?: string;
  dosingPumpComplianceId2?: number;
  dosingPumpComplianceId2Navigation?: ComplianceOptions;
  dosingPumpComment2?: string;
  dosingPump2?: number;
  aggregateSizeComplianceId2?: number;
  aggregateSizeComplianceId2Navigation?: ComplianceOptions;
  aggregateSizeComment2?: string;
  aggregateExcessiveComplianceId2?: number;
  aggregateExcessiveComplianceId2Navigation?: ComplianceOptions;
  aggregateExcessiveComment2?: string;
  aggregateDepthComplianceId2?: number;
  aggregateDepthComplianceId2Navigation?: ComplianceOptions;
  aggregateDepthComment2?: string;
  isDrainfield2Showable?: boolean;

  dateCreated: Date | string;
  createdBy: string;
  dateUpdated: Date;
  updatedBy: string;
  inspectionStatusId: number;
  distributionBoxOrHeader: string;
  elevationBenchmark: string;
  drainlineSeparationBedOrTrench: string;
  markAll: number;
};
export type ComplianceData = {
    id: number;
    name: string;

};

export type DrainfieldProductMakeOption = {
  drainfieldProductMakeId: number;
  drainfieldProductMakeValue: string;
};

export type DrainfieldProductModelOption = {
  drainfieldProductModelId: number;
  drainfieldProductModelValue: string;
  drainfieldProductMakeId: number;
};


export const schema = yup.object().shape({
    productComplianceId1: yup
    .number()
    .min(1, "Alt. Drainfield Product Compliance is required")
    .required("Alt. Drainfield Product Compliance is required")
    .typeError("Alt. Drainfield Product Compliance is required"),

    productMakeId1: yup.number().nullable(true)
    .when("productComplianceId1", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Drainfield Product Make is required")
        .required("Drainfield Product Make is required")
        .typeError("Drainfield Product Make is required")
    }),

    productModelId1: yup.number().nullable(true)
    .when("productComplianceId1", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Drainfield Product Model is required")
        .required("Drainfield Product Model is required")
        .typeError("Drainfield Product Model is required")
    }),

    productComment1: yup.string().nullable(true)
    .when("productComplianceId1", {
      is: (val: any) => val === Constants.Out_of_Compliance,
      then: yup.string().required("Alt. Drainfield Product Comment is required")
          .typeError("Alt. Drainfield Product Comment is required"),
    }),
  
    areaComplianceId: yup
    .number()
    .min(1, "Drainfield Area Compliance is required")
        .required("Drainfield Area Compliance is required")
        .typeError("Drainfield Area Compliance is required"),
   
    area1:
    yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
    .when("areaComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
      .min(1, "Drainfield Area 1 is required")
    .required("Drainfield Area 1 is required")
    .typeError("Drainfield Area 1 should be numeric")
}),


    areaComment: yup.string().nullable(true)
      .when("areaComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Drainfield Area Comment is required")
                .typeError("Drainfield Area Comment is required"),
        }),

    numberOfDrainline1:
        yup.number()
        .transform((value) => Number.isNaN(value)?null:value).nullable()
        .when("numberOfDrainlinesComplianceId",{
            is:(val:any) => val != Constants.Not_Applicable && val != Constants.Unobserved,
            then: 
            yup.number()
            .min(1, "Number of Drainline 1 is required")
            .required("Number of Drainline 1 is required") 
            .typeError("Number of Drainline 1 should be numeric")
                    }),
    numberOfUnits1:
        yup.number()
        .transform((value) => Number.isNaN(value)?null:value).nullable()
        .test(
        "max-decimals",
        "Number of Units can have up to 2 decimal places",
        (value) => value == null || /^\d+(\.\d{1,2})?$/.test(value.toString())
    )
      .when("numberOfDrainlinesComplianceId",{
        is:(val:any) => val != Constants.Not_Applicable && val != Constants.Unobserved,
            then: 
        yup.number()
        .min(1, "Number of Units is required")
        .required("Number of Units is required") 
        .typeError("Number of Units should be numeric"),
                    }),
    distributionComplianceId: yup
    .number()
    .min(1, "Distribution Box Compliance is required")
        .required("Distribution Box Compliance is required")
        .typeError("Distribution Box Compliance is required"),

    distributionBoxOrHeader: yup.number().nullable(true)
    .when("distributionComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Box or Header is required")
        .required("Box or Header is required")
        .typeError("Box or Header is required")
    }),
    ditributionComment: yup.string().nullable(true)
        .when("ditributionComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Distribution Comment is required")
                .typeError("Distribution Comment is required"),
        }),

    numberOfDrainlinesComplianceId: yup
        .number()
        .min(1, "Number of Drainlines Compliance is required")
        .required("Number of Drainlines Compliance is required")
        .typeError("Number of Drainlines Compliance is required"),

    numberOfDrainlinesComment: yup.string().nullable(true)
        .when("numberOfDrainlinesComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("NumberOfDrainlines Comment is required")
                .typeError("NumberOfDrainlines Comment is required"),
        }),

    drainlineSeparationComplianceId: yup
    .number()
        .min(1, "Drainline Separation Compliance is required")
        .required("Drainline Separation Compliance is required")
        .typeError("Drainline Separation Compliance is required"),
       
        drainlineSeparationBedOrTrench: yup.number().nullable(true)
    .when("drainlineSeparationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
        .min(1, "Bed or Trench is required")
        .required("Bed or Trench is required")
        .typeError("Bed or Trench is required")
    }),
    drainlineSeparationComment: yup.string().nullable(true)
        .when("drainlineSeparationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Drainline Separation Comment is required")
                .typeError("Drainline Separation Comment is required"),
        }),

    drainlineSlopeComplianceId: yup
        .number()
        .min(1, "Drainline Slope Compliance is required")
        .required("Drainline Slope Compliance is required")
        .typeError("Drainline Slope Compliance is required"),
    drainlineSlopeComment: yup.string().nullable(true)
        .when("drainlineSlopeComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Drainline Slope Comment is required")
                .typeError("Drainline Slope Comment is required"),
        }),
  distributionComment: yup.string().nullable(true)
      .when( "distributionComplianceId", {
        is: (val: any) => val === Constants.Out_of_Compliance,
        then: yup.string().required("Distribution Comment is required")
          .typeError("Distribution Comment is required")
      }),

    depthOfCoverComplianceId: yup
        .number()
        .min(1, "Depth of Absorption Surface Compliance is required")
        .required("Depth of Absorption Surface Compliance is required")
        .typeError("Depth of Absorption Surface Compliance is required"),
    depthOfCoverComment: yup.string().nullable(true)
        .when("depthOfCoverComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Depth of Absorption Surface Comment is required")
                .typeError("Depth of Absorption Surface Comment is required"),
        }),


    elevationComplianceId: yup
        .number()
        .min(1, "Elevation Compliance is required")
        .required("Elevation Compliance is required")
        .typeError("Elevation Compliance is required"),
    elevation1: yup.number().nullable(true) .transform((value) => Number.isNaN(value)?null:value).nullable()
    .when("elevationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
    .min(0, "Elevation (inches) is required")
    .required("Elevation (inches) is required") 
    .typeError("Elevation (inches) should be numeric"),
    }),
    elevationBenchmark: yup.number().nullable(true)
    .when("elevationComplianceId", {
      is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
      then:yup.number()
    .min(1, "Above or below benchmark is required")
        .required("Above or below benchmark is required")
        .typeError("Above or below benchmark is required"),
    }),
    elevationComment: yup.string().nullable(true)
        .when("elevationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Elevation Comment is required")
                .typeError("Elevation Comment is required"),
        }),


    systemLocationComplianceId: yup
        .number()
        .min(1, "Drainfield Location Compliance is required")
        .required("Drainfield Location Compliance is required")
        .typeError("Drainfield Location Compliance is required"),
    systemLocationComment: yup.string().nullable(true)
        .when("systemLocationComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Drainfield Location Comment is required")
                .typeError("Drainfield Location Comment is required"),
        }),


    dosingPumpComplianceId: yup
    .number()
        .min(1, "Dosing Pump Compliance is required")
        .required("Dosing Pump Compliance is required")
        .typeError("Dosing Pump Compliance is required"),
    dosingPump:yup.number().nullable(true) .transform((value) => Number.isNaN(value)?null:value).nullable()
     .when("dosingPumpComplianceId", {
        is: (val: any) => (val != Constants.Not_Applicable &&  val != Constants.Unobserved),
        then: yup.number()
        .min(1, "Number of Dosing Pumps is required")
        .required("Number of Dosing Pumps is required") 
        .typeError("Number of Dosing Pumps should be numeric"),
     }),
     
    dosingPumpComment: yup.string().nullable(true)
        .when("dosingPumpComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Dosing Pump Comment is required")
                .typeError("Dosing Pump Comment is required"),
        }),


    aggregateSizeComplianceId: yup
        .number()
        .min(1, "Mineral Aggregate Size Compliance is required")
        .required("Mineral Aggregate Size Compliance is required")
        .typeError("Mineral Aggregate Size Compliance is required"),
    aggregateSizeComment: yup.string().nullable(true)
        .when("aggregateSizeComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Mineral Aggregate Size Comment is required")
                .typeError("Mineral Aggregate Size Comment is required"),
        }),


    aggregateExcessiveComplianceId: yup
        .number()
        .min(1, "Mineral Aggregate Excessive Fines Compliance is required")
        .required("Mineral Aggregate Excessive Fines Compliance is required")
        .typeError("Mineral Aggregate Excessive Fines Compliance is required"),
    aggregateExcessiveComment: yup.string().nullable(true)
        .when("aggregateExcessiveComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Mineral Aggregate Excessive Fines Comment is required")
                .typeError("Mineral Aggregate Excessive Fines Comment is required"),
        }),
    aggregateDepthComplianceId: yup
        .number()
        .min(1, "Mineral Aggregate Depth Compliance is required")
        .required("Mineral Aggregate Depth Compliance is required")
        .typeError("Mineral Aggregate Depth Compliance is required"),
    aggregateDepthComment: yup.string().nullable(true)
        .when("aggregateDepthComplianceId", {
            is: (val: any) => val === Constants.Out_of_Compliance,
            then: yup.string().required("Mineral Aggregate Depth Comment is required")
                .typeError("Mineral Aggregate Depth Comment is required"),
        }),
    productComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Alt. Drainfield Product Compliance is required")
          .required("Alt. Drainfield Product Compliance is required")
          .typeError("Alt. Drainfield Product Compliance is required")
      }),
    productMakeId2: yup.number().nullable(true)
      .when(["isDrainfield2Showable", "productComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Drainfield Product Make is required")
          .required("Drainfield Product Make is required")
          .typeError("Drainfield Product Make is required")
      }),
    productModelId2: yup.number().nullable(true)
      .when(["isDrainfield2Showable", "productComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Drainfield Product Model is required")
          .required("Drainfield Product Model is required")
          .typeError("Drainfield Product Model is required")
      }),
    productComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "productComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Alt. Drainfield Product Comment is required")
          .typeError("Alt. Drainfield Product Comment is required")
      }),
    areaComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Drainfield Area Compliance is required")
          .required("Drainfield Area Compliance is required")
          .typeError("Drainfield Area Compliance is required")
      }),
    area2: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
      .when(["isDrainfield2Showable", "areaComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Drainfield Area is required")
          .required("Drainfield Area is required")
          .typeError("Drainfield Area should be numeric")
      }),
    areaComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "areaComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Drainfield Area Comment is required")
          .typeError("Drainfield Area Comment is required")
      }),
    distributionComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Distribution Box Compliance is required")
          .required("Distribution Box Compliance is required")
          .typeError("Distribution Box Compliance is required")
      }),
    distributionBoxOrHeader2: yup.number().nullable(true)
      .when(["isDrainfield2Showable", "distributionComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Box or Header is required")
          .required("Box or Header is required")
          .typeError("Box or Header is required")
      }),
    distributionComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "distributionComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Distribution Comment is required")
          .typeError("Distribution Comment is required")
      }),
    numberOfDrainlinesComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Number of Drainlines Compliance is required")
          .required("Number of Drainlines Compliance is required")
          .typeError("Number of Drainlines Compliance is required")
      }),
    numberOfDrainlinesComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "numberOfDrainlinesComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Number Of Drainlines Comment is required")
          .typeError("Number Of Drainlines Comment is required")
      }),
    numberOfDrainline12: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
      .when(["isDrainfield2Showable", "numberOfDrainlinesComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Number of Drainline is required")
          .required("Number of Drainline is required")
          .typeError("Number of Drainline should be numeric")
      }),
    numberOfUnits2: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
    .test(
        "max-decimals",
        "Number of Units can have up to 2 decimal places",
        (value) => value == null || /^\d+(\.\d{1,2})?$/.test(value.toString())
    )  
    .when(["isDrainfield2Showable", "numberOfDrainlinesComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Number of Units is required")
          .required("Number of Units is required")
          .typeError("Number of Units should be numeric")
      }),
    drainlineSeparationComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Drainline Separation Compliance is required")
          .required("Drainline Separation Compliance is required")
          .typeError("Drainline Separation Compliance is required")
      }),
    drainlineSeparationBedOrTrench2: yup.number().nullable(true)
      .when(["isDrainfield2Showable", "drainlineSeparationComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Bed or Trench is required")
          .required("Bed or Trench is required")
          .typeError("Bed or Trench is required")
      }),
    drainlineSeparationComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "drainlineSeparationComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Drainline Separation Comment is required")
          .typeError("Drainline Separation Comment is required")
      }),
    drainlineSlopeComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Drainline Slope Compliance is required")
          .required("Drainline Slope Compliance is required")
          .typeError("Drainline Slope Compliance is required")
      }),
    drainlineSlopeComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "drainlineSlopeComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Drainline Slope Comment is required")
          .typeError("Drainline Slope Comment is required")
      }),
    depthOfCoverComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Depth of Absorption Surface Compliance is required")
          .required("Depth of Absorption Surface Compliance is required")
          .typeError("Depth of Absorption Surface Compliance is required")
      }),
    depthOfCoverComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "depthOfCoverComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Depth of Absorption Surface Comment is required")
          .typeError("Depth of Absorption Surface Comment is required")
      }),
    elevationComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Elevation Compliance is required")
          .required("Elevation Compliance is required")
          .typeError("Elevation Compliance is required")
      }),
    elevation12: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
      .when(["isDrainfield2Showable", "elevationComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(0, "Elevation (inches) is required")
          .required("Elevation (inches) is required")
          .typeError("Elevation (inches) should be numeric")
      }),
    elevationBenchmark2: yup.number().nullable(true)
      .when(["isDrainfield2Showable", "elevationComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Above or below benchmark is required")
          .required("Above or below benchmark is required")
          .typeError("Above or below benchmark is required")
      }),
    elevationComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "elevationComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Elevation Comment is required")
          .typeError("Elevation Comment is required")
      }),
    systemLocationComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Drainfield Location Compliance is required")
          .required("Drainfield Location Compliance is required")
          .typeError("Drainfield Location Compliance is required")
      }),
    systemLocationComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "systemLocationComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Drainfield Location Comment is required")
          .typeError("Drainfield Location Comment is required")
      }),
    dosingPumpComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Dosing Pump Compliance is required")
          .required("Dosing Pump Compliance is required")
          .typeError("Dosing Pump Compliance is required")
      }),
    dosingPump2: yup.number().nullable(true).transform((value) => Number.isNaN(value) ? null : value)
      .when(["isDrainfield2Showable", "dosingPumpComplianceId2"], {
        is: (show: boolean, val: any) => show && val != Constants.Not_Applicable && val != Constants.Unobserved,
        then: yup.number().min(1, "Number of Dosing Pumps is required")
          .required("Number of Dosing Pumps is required")
          .typeError("Number of Dosing Pumps should be numeric")
      }),
    dosingPumpComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "dosingPumpComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Dosing Pump Comment is required")
          .typeError("Dosing Pump Comment is required")
      }),
    aggregateSizeComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Mineral Aggregate Size Compliance is required")
          .required("Mineral Aggregate Size Compliance is required")
          .typeError("Mineral Aggregate Size Compliance is required")
      }),
    aggregateSizeComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "aggregateSizeComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Mineral Aggregate Size Comment is required")
          .typeError("Mineral Aggregate Size Comment is required")
      }),
    aggregateExcessiveComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Mineral Aggregate Excessive Fines Compliance is required")
          .required("Mineral Aggregate Excessive Fines Compliance is required")
          .typeError("Mineral Aggregate Excessive Fines Compliance is required")
      }),
    aggregateExcessiveComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "aggregateExcessiveComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Mineral Aggregate Excessive Fines Comment is required")
          .typeError("Mineral Aggregate Excessive Fines Comment is required")
      }),
    aggregateDepthComplianceId2: yup.number().nullable(true)
      .when("isDrainfield2Showable", {
        is: true,
        then: yup.number().min(1, "Mineral Aggregate Depth Compliance is required")
          .required("Mineral Aggregate Depth Compliance is required")
          .typeError("Mineral Aggregate Depth Compliance is required")
      }),
    aggregateDepthComment2: yup.string().nullable(true)
      .when(["isDrainfield2Showable", "aggregateDepthComplianceId2"], {
        is: (show: boolean, val: any) => show && val === Constants.Out_of_Compliance,
        then: yup.string().required("Mineral Aggregate Depth Comment is required")
          .typeError("Mineral Aggregate Depth Comment is required")
      }),
   
  
});
